import { Link, LinkProps } from 'react-router';

export const LinkWithPrevLocation = (props: LinkProps) => {
    return <Link {...props} state={{ ...props.state, prevLocation: location.pathname }} />;
};
